<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-sizes="pageSizes"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default () {
        return [10, 25, 50, 100]
      }
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
    }
  },

  methods: {
    handleSizeChange (val) {
      this.$emit('change', { pageSize: val, pageNum: 1 })
    },
    handleCurrentChange (val) {
      this.$emit('change', { pageNum: val, pageSize: this.pageSize })
    }
  }
}
</script>

<style lang="less" scoped>
.base {
  margin: 0 2px;
  padding: 0 15px;
  height: 34px;
  line-height: 34px;
  border-radius: 5px;
  color: @color-primary;
}
.el-pagination {
  color: @color-primary;
  text-align: right;
  padding-right: 0;
  .f-s-14();
  /deep/ .btn-prev, /deep/ .btn-next {
    .base();
  }
  /deep/ .el-pager .number {
    .base();
    font-weight: normal;
  }
  /deep/ .el-pager li.active {
    background-color: #C1D9EE;
    cursor: default;
  }
  /deep/ .el-pagination__total {
    .base();
  }
  /deep/ .el-pager li.btn-quicknext, /deep/ .el-pager li.btn-quickprev {
    .base();
  }
  /deep/ .el-pagination__sizes {
    .base();
    .el-input__inner {
      .base();
      border: none;
    }
    .is-focus {
      .el-input__inner {
        background-color: #C1D9EE;
      }
    }
  }

  /deep/ .el-pagination__jump {
    .base();
    padding-right: 0;
    margin-right: 0;
    .el-pagination__editor {
      padding-right: 0;
    }
    .el-input__inner {
      color: @color-primary;
      padding-right: 0;
    }
  }
}
</style>

<style lang="less">

.el-scrollbar .el-select-dropdown__list {
  background-color: @color-primary;
  color: #fff;
  .el-select-dropdown__item {
    color: #fff;
    font-weight: normal;
    .f-s-14();
    &:hover {
      font-weight: normal;
      background-color: @color-blue;
      .f-s-14();
    }
  }
  // .hover {
  //   background-color: @color-primary;
  // }
  .selected {
    font-weight: normal;
    background-color: @color-blue;
    .f-s-14();
  }
}
.el-select-dropdown__item.hover {
  background-color: @color-blue;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  background-color: @color-blue;
  color: #fff;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: @color-blue;
  color: #fff;
}
.el-select-dropdown {
  margin: 0;
}
.el-popper[x-placement^=bottom] {
  margin: 0;
}
.el-popper .popper__arrow, .el-popper .popper__arrow::after {
  display: none;
}
</style>
